"use client";
import { Col } from "@/app/components/lib/my-bootstrap";
import ProductStartFrom from "./ProductStartFrom";
import ProductPrice from "./ProductPrice";
import ProductPriceInfoButton from "./product-price-info/ProductPriceInfoButton";
import BtnExpandingAddToCard from "./btn-expanding-add-to-card/BtnExpandingAddToCard";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useState } from "react";
import calculatPricesForSpecialPrices from "@/utils/functions/calculatPriceForSpecialPrices";
import { IProduct_Category_Config_Customize } from "@/api/AppApi/services/home/interfaces/ICategory";
import { useIsSmallScreen } from "./useIsSmallScreen";

interface Props extends IProduct {
  size: Size;
  theme: ITheme;
  Customize?: IProduct_Category_Config_Customize;
  scrollableTabs: boolean;
  showCustomEventData?: boolean;
}
const ProductBoxTail: React.FC<Props> = ({
  theme,
  size,
  preview_type,
  Customize,
  scrollableTabs,
  showCustomEventData,
  ...productProps
}) => {
  const [quantity, setQuantity] = useState(0);
  let hasShowPrice = false;
  try {
    hasShowPrice =
      Customize != null &&
      Object.prototype.hasOwnProperty.call(Customize, "show_price");
  } catch (e) {
    console.error("Error checking for show_price property:", e);
  }

  const { show_price } = Customize ?? {};
  const showPrice = hasShowPrice ? show_price : true;
  const {
    selling_prices: special_prices,
    is_configurable,
    has_required_addons,
    price_without_discount,
    price: originalPrice,
    id,
    max_quantity_in_cart,
    min_quantity_in_cart,
    slug,
    quantity_on_hand,
    thumbnail_url,
    units,
    has_term_and_condition,
    has_configurable_parent,
    has_required_fields,
    custom_data,
  } = productProps;
  const { show_add_to_card_btn, add_to_cart_style } =
    theme?.components?.product ?? {};

  const isEventBox = preview_type === "event" && !!showCustomEventData;

  const showAddToCardBtn = show_add_to_card_btn;
  const smallBox = [Size.small, Size.vertical_small].includes(size);
  const isHor = useIsSmallScreen() && scrollableTabs;
  const verticalBtn =
    !isEventBox && (add_to_cart_style === "plus_icon" || isHor);

  const isSmallBoxHorBtn = smallBox && !verticalBtn;
  const allowAddConfigurableProductToCart =
    theme?.components?.product?.allow_add_configurable_product_to_cart || false;
  const show_all_product_units =
    theme?.components?.product?.show_all_product_units;

  const isConfigurableProduct =
    (allowAddConfigurableProductToCart &&
      is_configurable &&
      (preview_type === ProductPreviewTypes.general ||
        preview_type === ProductPreviewTypes.consultation)) ||
    (!!units.length && show_all_product_units);

  const isService = getIsService(preview_type as ProductPreviewTypes);
  const viewDetails =
    isService ||
    has_required_addons ||
    is_configurable ||
    has_term_and_condition ||
    has_configurable_parent ||
    has_required_fields ||
    (!!units.length && show_all_product_units);
  const { price, price_without_discount: priceWithoutDiscount } =
    calculatPricesForSpecialPrices({
      originalPrice,
      originalPriceWithoutDiscount: price_without_discount,
    })({ quantity, specialPrices: special_prices });
  const handleQuantityChange = (quantity: number) => {
    setQuantity(quantity);
  };

  return (
    <div
      className={`product-tail ${isSmallBoxHorBtn ? "small-Box-hor-btn" : ""}`}
    >
      {showPrice && !isEventBox && (
        <>
          <Col className="p-0">
            <ProductStartFrom
              is_configurable={is_configurable || has_required_addons}
            />
            <ProductPrice
              priceWithoutDiscount={priceWithoutDiscount}
              price={price}
              sameLine={!(special_prices || []).length}
            />
          </Col>
          {(special_prices || [])?.length > 1 && (
            <Col
              className="p-0 align-self-end "
              style={{ marginInline: "5px" }}
            >
              <ProductPriceInfoButton priceInfoData={special_prices} />
            </Col>
          )}
        </>
      )}
      {showAddToCardBtn && (
        <Col
          className={`p-0 d-flex justify-content-end ${
            isSmallBoxHorBtn ? "w-100" : ""
          }`}
        >
          <BtnExpandingAddToCard
            HBFullWidth={isSmallBoxHorBtn || isEventBox}
            productId={id}
            viewDetails={viewDetails}
            vertical={verticalBtn}
            image_url={thumbnail_url}
            quantity_on_hand={quantity_on_hand}
            max_quantity_in_cart={max_quantity_in_cart}
            min_quantity_in_cart={min_quantity_in_cart}
            productSlug={slug}
            isConfigurableProduct={isConfigurableProduct}
            onQuantityChange={handleQuantityChange}
            preview_type={preview_type}
            custom_data={custom_data}
          />
        </Col>
      )}
    </div>
  );
};

export default ProductBoxTail;

const getIsService = (type: ProductPreviewTypes) => {
  switch (type) {
    case ProductPreviewTypes.appointment:
    case ProductPreviewTypes.consultation:
      return true;
    case ProductPreviewTypes.general:
    default:
      return false;
  }
};
